<app-loader></app-loader>
<app-header *ngIf="authService.isLoggedIn() && authService.getClient()?.code"></app-header>
<router-outlet></router-outlet>